module.exports = __webpack_public_path__ + "img/delivery.240d22b2.svg";